import { makeStyles } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useIsFeatureEnabled } from '../../../api/features/features';
import { ReportsTableFilteringContextProvider } from '../../../contexts/reportsTable/reportsTableFilteringContext';
import { ReportsTableFilteringContextProvider as LegacyReportsTableFilteringContextProvider } from '../../../contexts/reportsTable/reportsTableFilteringContext.legacy';
import { searchOnType, SearchTableContextProvider } from '../../../contexts/searchTableContext';
import { BulkEditReturnsEnabled } from '../../../utils/FeatureFlags.constants';
import LoadingSpinner from '../../common/LoadingSpinner';
import ReportsTable from './ReportsTable';
import ReportsTableLegacy from './ReportsTable.legacy';

const useStyles = makeStyles({
    // Match ReportsTable's wrapper height so the spinner sits in the same allotted content area.
    wrapper: {
        width: '100%',
        height: 'calc(100vh - 120px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const NewFilterableReportsTable = () => (
    <SearchTableContextProvider searchOn={searchOnType.ListOfReports}>
        <ReportsTableFilteringContextProvider>
            <ReportsTable />
        </ReportsTableFilteringContextProvider>
    </SearchTableContextProvider>
);

const LegacyFilterableReportsTable = () => (
    <SearchTableContextProvider searchOn={searchOnType.ListOfReports}>
        <LegacyReportsTableFilteringContextProvider>
            <ReportsTableLegacy />
        </LegacyReportsTableFilteringContextProvider>
    </SearchTableContextProvider>
);

const FilterableReportsTable = () => {
    const { t } = useTranslation();
    const styles = useStyles();
    const { data: isBulkEditReturnsEnabled, isLoading } = useIsFeatureEnabled({ featureFlagName: BulkEditReturnsEnabled });

    // Wait for the flag before mounting either tree so we never flash the wrong filter bar (legacy Fluent
    // filters vs the new toolbar-scoped filters) while the query is in flight.
    if (isLoading) {
        return (
            <div className={styles.wrapper}>
                <LoadingSpinner data-testid='loadingSpinner' id='loadingSpinner' label={t('loadingPleaseWait').toString()} />
            </div>
        );
    }

    return isBulkEditReturnsEnabled ? <NewFilterableReportsTable /> : <LegacyFilterableReportsTable />;
};

export default FilterableReportsTable;
